import _defineProperty from "@babel/runtime/helpers/defineProperty";
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
import { css } from '@emotion/react';
import { PanelSharedCssClassName } from '@atlaskit/editor-common/panel';
import { expandClassNames, SmartCardSharedCssClassName } from '@atlaskit/editor-common/styles';
import { CodeBlockSharedCssClassName } from './codeBlockStyles';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var firstBlockNodeStyles = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.ProseMirror': _defineProperty(_defineProperty({}, "> .".concat(PanelSharedCssClassName.prefix, ", > .").concat(CodeBlockSharedCssClassName.CODEBLOCK_CONTAINER, ", > .").concat(SmartCardSharedCssClassName.BLOCK_CARD_CONTAINER, ", > div[data-task-list-local-id], > div[data-layout-section], > .").concat(expandClassNames.prefix), {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:first-child': {
      marginTop: 0
    }
  }), '> hr:first-child, > .ProseMirror-widget:first-child + hr', {
    marginTop: 0
  })
});